webpackJsonp([114276838955818,60335399758886],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/layout-index.json":
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/home/circleci/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/home/circleci/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/home/circleci/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/home/circleci/repo/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/home/circleci/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/home/circleci/repo/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./.cache/layouts/index.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__("./src/layouts/index.js");
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__("./node_modules/json-loader/index.js!./.cache/json/layout-index.json");
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ "./src/layouts/index.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _typography = __webpack_require__("./src/utils/typography.js");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  children: PropTypes.func.isRequired
	};
	
	var DefaultLayout = function (_React$Component) {
	  _inherits(DefaultLayout, _React$Component);
	
	  function DefaultLayout() {
	    _classCallCheck(this, DefaultLayout);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  DefaultLayout.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      {
	        style: {
	          margin: "0 auto",
	          marginTop: (0, _typography.rhythm)(1.5),
	          marginBottom: (0, _typography.rhythm)(1.5),
	          maxWidth: 650,
	          paddingLeft: (0, _typography.rhythm)(3 / 4),
	          paddingRight: (0, _typography.rhythm)(3 / 4)
	        }
	      },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { style: { textDecoration: "none" }, to: "/" },
	        _react2.default.createElement(
	          "h3",
	          { style: { color: "tomato", marginBottom: (0, _typography.rhythm)(1.5) } },
	          "Example of using Contentful as a data source for a Gatsby site"
	        )
	      ),
	      this.props.children(),
	      _react2.default.createElement("hr", { style: { marginTop: (0, _typography.rhythm)(3) } }),
	      _react2.default.createElement(
	        "p",
	        null,
	        "The src for this website is at",
	        " ",
	        _react2.default.createElement(
	          "a",
	          { href: "https://github.com/gatsbyjs/gatsby/tree/master/examples/using-contentful" },
	          "https://github.com/gatsbyjs/gatsby/tree/master/examples/using-contentful"
	        )
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "The Contentful site that is providing the data for this site is at",
	        " ",
	        _react2.default.createElement(
	          "a",
	          { href: "https://discovery.contentful.com/entries/by-content-type/2PqfXUJwE8qSYKuM0U6w8M?delivery_access_token=e481b0f7c5572374474b29f81a91e8ac487bb27d70a6f14dd12142837d8e980a&space_id=ubriaw6jfhm1" },
	          "https://discovery.contentful.com/entries/by-content-type/2PqfXUJwE8qSYKuM0U6w8M?delivery_access_token=e481b0f7c5572374474b29f81a91e8ac487bb27d70a6f14dd12142837d8e980a&space_id=ubriaw6jfhm1"
	        )
	      )
	    );
	  };
	
	  return DefaultLayout;
	}(_react2.default.Component);
	
	DefaultLayout.propTypes = propTypes;
	
	exports.default = DefaultLayout;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-8eec3bf646019e238836.js